import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton} from "@mui/material";
import React from "react";
import {observer} from "mobx-react";
import PropTypes from 'prop-types';
import ConditionalComponent from "../Shared/ConditionalComponent";
import Utility from "../../Utility";
import {useStores} from "../../Hooks";
import CloseIcon from "@mui/icons-material/Close";
import {ArrowBack, ArrowForward} from "@mui/icons-material";
import GlobalUtility from "../../Utilities/GlobalUtility";

const GeneralDialog = observer(props => {
    const {modalStore, generalStore} = useStores();

    const {
        openControl,
        specialOnClose,
        cancelText,
        preserveDataOnClose,
        className,
        onEnter,
        disableBackdropClick,
        disableEscapeKeyDown,
        title,
        body,
        onConfirm,
        noCancel,
        importButton,
        isConfirmDisabled,
        confirmText,
        buttonClass,
        dialogFooter,
        extraClose,
        divider,
        goBackControl,
        headerClassName,
        buttonsClassName,
        bodyClassName,
        headerStyle = {},
        dialogStyle = {},
        iconConfirmation,
        isChangedColorButtons,
        maxWidth,
        fullWidth,
        maxHeight,
        'data-testid': dataTestId,
    } = props;

    function closeModal() {
        if (specialOnClose) {
            specialOnClose();
            return;
        }
        if (!!modalStore.modalData && !!modalStore.modalData.toggleMenu) {
            modalStore.modalData.toggleMenu(null)
        }
        if (!preserveDataOnClose) {
            modalStore[openControl] = false;
            Utility.sleep(100).then(() => modalStore.resetModalData());
        }
        modalStore[openControl] = false;
    }

    const goBack = () => {
        modalStore[openControl] = false;
        modalStore[goBackControl] = true;
    }

    const isGuidesOn =  GlobalUtility.isFlagOn(generalStore, 'IsCanImportFromGuides')

    return (

        <Dialog
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            data-testid={dataTestId}
            className={`dialog ${className}`}
            open={modalStore[openControl] || false}
            onClose={(e, reason) => {
                if (reason === 'backdropClick' && disableBackdropClick) {
                    return;
                }
                if (reason === 'escapeKeyDown' && disableEscapeKeyDown) {
                    return;
                }
                closeModal();
            }}
            TransitionProps={{
                onEnter
            }}
            PaperProps={{
                ...maxHeight ? {} : {className: 'dialog-paper'},
                style: dialogStyle
            }}
        >
            <ConditionalComponent if={!!extraClose}>
                <IconButton data-testid="dialog-close-button" onClick={closeModal} className='extra-close'>
                    <CloseIcon/>
                </IconButton>
            </ConditionalComponent>
            <ConditionalComponent if={!!goBackControl}>
                <IconButton onClick={goBack} className='go-back'>
                    {generalStore.langDir === "rtl" ? <ArrowForward/> : <ArrowBack/>}
                </IconButton>
            </ConditionalComponent>
            <ConditionalComponent if={title}>
                <DialogTitle style={headerStyle} className={`dialog-header ${headerClassName}`}>{title}</DialogTitle>
            </ConditionalComponent>

            <ConditionalComponent if={divider}>
                <Divider className='divider'/>
            </ConditionalComponent>
            <DialogContent className={`dialog-body special-scroll ${bodyClassName ? bodyClassName : ''}`}>{body}</DialogContent>
            <ConditionalComponent if={!!onConfirm}>
                <DialogActions className={` ${buttonsClassName ? 'dialog-buttons media-library' : 'dialog-buttons'}`}>
                    <ConditionalComponent if={!noCancel}>
                        <Button variant='contained' data-testid="dialog-cancel-button" className={`${isChangedColorButtons? 'ok-button' : 'cancel-button'} ${buttonClass || ""}`}
                                onClick={closeModal}>{cancelText ?? generalStore.translate('cancel')}</Button>
                    </ConditionalComponent>
                    <Button variant='contained' data-testid="dialog-confirm-button" className={`${isChangedColorButtons? 'cancel-button' :'ok-button'} theme-button ${buttonClass || ""}`} onClick={onConfirm}
                            disabled={isConfirmDisabled}>
                        <ConditionalComponent if={!!iconConfirmation}>
                            {iconConfirmation}
                        </ConditionalComponent>
                        {confirmText}
                    </Button>
                    <ConditionalComponent if={importButton && isGuidesOn}>
                        {importButton}
                    </ConditionalComponent>
                </DialogActions>
            </ConditionalComponent>
            <ConditionalComponent if={!!dialogFooter}>
                <div className="dialog-footer">{dialogFooter}</div>
            </ConditionalComponent>
        </Dialog>
    );
});
GeneralDialog.propTypes = {
    openControl: PropTypes.string.isRequired,
    className: PropTypes.string,
    onEnter: PropTypes.func,
    title: PropTypes.any,
    body: PropTypes.any,
    onConfirm: PropTypes.func,
    isConfirmDisabled: PropTypes.bool,
    confirmText: PropTypes.string,
    preserveDataOnClose: PropTypes.bool,
    noCancel: PropTypes.bool,
    specialOnClose: PropTypes.func,
    extraClose: PropTypes.bool,
    headerClassName: PropTypes.string,
    headerStyle: PropTypes.any,
    dialogStyle: PropTypes.any,
    iconConfirmation: PropTypes.any,
    dialogFooter: PropTypes.any,
    importButton: PropTypes.any,
};

export default GeneralDialog;
